import config from "../../app.json";
import axios from "axios";
import { trackGooglePurchaseSuccess } from "../../Utils/GoogleAnalytics";
import { numberHasDecimal, emailValidation } from "../../helper";

import { Context } from "../../Reducers/Store";
import { Row, Col, Button } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import FieldText from "../Fields/FieldText";
import Rectangle from "../Rectangle/rectangle";
import AlertComponent from "../AlertComponent";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faLock } from "@fortawesome/free-solid-svg-icons";

import { Elements, useStripe, useElements, CardCvcElement, CardNumberElement, CardExpiryElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(config.STRIPE);
import Image from "../Image/image";
import Bolt from "../../Assets/Images/zap.svg";
import MonkeyFace from "../../Assets/Images/monkey-face.svg";
import Nope from "../../Assets/Images/nope.svg";
import NormalCheck from "../../Assets/Images/check.svg";
import CheckSpecial from "../../Assets/Images/check-special.svg";

import "./PaymentInfoMobile.scss";
import PeriodicityOption from "../PeriodicityOption/periodicityoption";

const PaymentInfoMobile = () => {
  let navigate = useNavigate();
  const location = useLocation();

  const [state, dispatch] = useContext(Context);
  // const [subscription, setSubscription] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [planUpdate, setPlanUpdate] = useState(false);
  const [planData, setPlanData] = useState(null);
  const [promoCode, setPromoCode] = useState(null);
  const [billingEmail, setBillingEmail] = useState(null);

  const [planId, setPlanId] = useState(null);
  const [priceMonthId, setPriceMonthId] = useState(0);
  const [priceYearId, setPriceYearId] = useState(0);
  const [priceId, setPriceId] = useState(0);
  const [periodicity, setPeriodicity] = useState(null);
  const [freeTrialDays, setFreeTrialDays] = useState(0);

  const [jwtMobile, setJwtMobile] = useState(null);

  useEffect(() => {
    if (location?.state) {
      setPlanId(location?.state.planId);
      setPriceMonthId(location?.state.planPriceMonthId);
      setPriceYearId(location?.state.planPriceYearId);
      setPeriodicity(location?.state.planPeriodicity);
      setPlanData(location?.state);
      setPlanUpdate(location?.state.planSubscriptionId);
      setFreeTrialDays(location?.state.freeTrialDays ?? 0);
      setJwtMobile(location?.state.jwtMobile);
    }
  }, [location?.state]);

  useEffect(() => {
    if (subscriptionId && jwtMobile) {
      navigate("/successmobile");
    }
  }, [subscriptionId]);

  useEffect(() => {
    setPriceId(periodicity === "mo" ? priceMonthId : priceYearId);
  }, [periodicity]);

  const handleCardToken = (error, token) => {
    if (error) {
      return AlertComponent("Error", error.message, { icon: `error` });
    } else {
      const payload = {
        planId: planId,
        priceId: priceId,
        promoCode: promoCode,
        payment: {
          stripeCardToken: token.id,
          billingEmail: billingEmail,
        },
      };

      const optionsCall = {
        headers: { Authorization: "Bearer " + jwtMobile },
      };

      axios
        .post(config.API_HM + "/subscriptions", payload, optionsCall)
        .then((res) => {
          setSubscriptionId(res.data.id);
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.response?.data?.message || error?.message, { icon: `error` });
        });
    }
  };

  return (
    <div className="payment-info">
      <Row>
        <Elements stripe={stripePromise} options={{ appearance: { theme: "flat" } }}>
          <SubmitForm
            callbackCardToken={handleCardToken}
            planData={planData}
            changePromoCode={setPromoCode}
            changeBillingEmail={setBillingEmail}
            changePeriodicity={setPeriodicity}
            freeTrialDays={freeTrialDays}
          />
        </Elements>
      </Row>
    </div>
  );
};
export default PaymentInfoMobile;

const SubmitForm = ({ callbackCardToken, planData, changePromoCode, changeBillingEmail, changePeriodicity, freeTrialDays }) => {
  const [state, dispatch] = useContext(Context);
  const [billingEmail, setBillingEmail] = useState(null);
  const [selectedPeriodicity, setSelectedPeriodicity] = useState(planData?.planPeriodicity);

  const [promoCode, setPromoCode] = useState(null);
  const [showPromoCode, setShowPromoCode] = useState(false);
  const [billingMailError, setBillingMailError] = useState(null);
  const [isValidPromoCode, setIsValidPromoCode] = useState(false);

  const handlePromoCode = (value) => {
    changePromoCode(value);
    setPromoCode(value);
  };

  const handleBillingEmail = (value) => {
    changeBillingEmail(value);
    setBillingEmail(value);
  };

  const handleOptionChange = (value) => {
    changePeriodicity(value);
    setSelectedPeriodicity(value);
  };

  useEffect(() => {
    if (planData) {
      setSelectedPeriodicity(planData?.planPeriodicity);
    }
  }, [planData?.planPeriodicity]);

  const stripe = useStripe();
  const elements = useElements({ theme: "stripe" });

  const handleSubmit = async (e, showMessage) => {
    e.preventDefault();
    if (!emailValidation(billingEmail)) {
      setBillingMailError("Invalid email");
      return false;
    }
    setBillingMailError(null);
    if (promoCode && !isValidPromoCode) {
      AlertComponent("Error", "Promo Code is invalid", { icon: `error` });
      return false;
    }
    return true;
  };

  const triggerPurchaseSuccess = (ret) => {
    if (config.GOOGLE_ANALYTICS) {
      const finalPrice = selectedPeriodicity === "mo" ? numberHasDecimal(planData?.planPriceMonth) : numberHasDecimal(planData?.planFullPriceYear);

      // Documentation:
      //https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce

      const purchaseData = {
        currency: "USD",
        transaction_id: ret.token.id,
        affiliation: "Socialchimp",
        value: finalPrice,
        coupon: promoCode,
      };

      const itemData = {
        item_id: `SKU_${planData?.planId}`, // Tansaction ID
        item_name: planData?.planName,
        affiliation: "Socialchimp",
        price: finalPrice,
        coupon: promoCode,
        item_category: selectedPeriodicity === `mo` ? "monthly" : "yearly",
        index: 0,
        quantity: 1,
        item_brand: "Socialchimp",
        sku: planData?.planId,
      };

      purchaseData.simpleItem = JSON.stringify(itemData);
      purchaseData.items = [itemData];

      trackGooglePurchaseSuccess(purchaseData);
    }
  };

  const checkPromoCode = async () => {
    let isValid = false;

    if (promoCode) {
      const payload = {
        promoCode: promoCode,
      };

      await axios
        .post(config.API_HM + "/subscriptions/promocode/validate", payload)
        .then((x) => {
          if (x.status === 200) {
            isValid = true;
          }
        })
        .catch(() => {
          isValid = false;
        });

      setIsValidPromoCode(isValid);
      return isValid;
    } else {
      return true;
    }
  };

  const fetchCardToken = async (e) => {
    const submitOk = await handleSubmit(e);
    if (!submitOk) {
      e.preventDefault();
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    dispatch({ type: "SET_LOADING", payload: true });
    const ret = await stripe.createToken(cardElement, {
      type: "card",
    });
    dispatch({ type: "SET_LOADING", payload: false });

    triggerPurchaseSuccess(ret);

    callbackCardToken(ret.error, ret.token);
  };

  // const payText = `Start SocialChimp ${planData?.planName}`;
  const payText = `Start free trial`;
  const chargingPrice = selectedPeriodicity === `mo` ? planData?.planPriceMonth : planData?.planFullPriceYear;
  let billedToday = numberHasDecimal(isValidPromoCode ? 0 : chargingPrice);
  if (freeTrialDays > 0) {
    billedToday = 0;
  }

  const sevenDaytrialText = freeTrialDays > 0 ? ` after your free ${freeTrialDays} day trial` : "";

  const chargePeriod = selectedPeriodicity === `mo` ? "every month" : "for a full year";
  const chargePrice = numberHasDecimal(chargingPrice);

  let savePercentageText = "Save ";
  if (planData?.planPriceMonth > 0 && planData?.planPriceYearPerMonth > 0) {
    const correctPercentage = (planData?.planPriceYearPerMonth * 100) / planData?.planPriceMonth;
    savePercentageText += 100 - numberHasDecimal(Math.floor(correctPercentage), 2) + "%";
  }
  return (
    <div className="stripe-container mobile-plan-top mobile-view">
      <div className={`logo-subscription`} style={{ display: "flex", justifyContent: "center" }}>
        <Row>
          <Col className="col-md-12">
            <Image src={MonkeyFace} width={50} height={50} />
          </Col>
        </Row>
      </div>
      <div className={`header-subscription`} style={{ display: "flex", justifyContent: "center" }}>
        <Row>
          <Col className="col-md-12 modile-plan-header">
            <h6 className="mobile-plan-title">A 10x faster way to create your Marketing Copy</h6>
          </Col>
        </Row>
      </div>
      {planData && (
        <div className={`plan-discriminator`}>
          <div className="selected-plan-badge">Selected Plan</div>

          <div className="selected-plan">
            <span className="plan-name">{planData?.planName}</span>
            {planData?.planBestOption && <Rectangle title="Popular" className="plan-badge" />}
          </div>
          <div className="plan-section">
            <span className="plan-price">${chargePrice}</span>
            <span className="plan-periodicity">{`${selectedPeriodicity === `mo` ? `Montly` : `Yearly`} Plan`}</span>
          </div>
          {planData.planAllFeatures?.map((x, index) => {
            return (
              <div className="item-plan" key={`main_benefits_${index}`}>
                <span className="plan-benefits-icon">
                  <FontAwesomeIcon icon={faCircleCheck}></FontAwesomeIcon>
                </span>
                <span className="plan-benefits-text">{x}</span>
              </div>
            );
          })}
        </div>
      )}
      <div className={`stripe-elements`}>
        <div className="payment-secured">
          <span className="plan-lock">
            <FontAwesomeIcon icon={faLock}></FontAwesomeIcon>
          </span>
          <span className="plan-lock-instruction">This is a secure form with Stripe</span>
        </div>
        <Row>
          <div className="periodicity-opt">
            <PeriodicityOption
              periodicity="monthly"
              value="mo"
              selected={selectedPeriodicity === "mo"}
              price={numberHasDecimal(planData?.planPriceMonth)}
              onClick={handleOptionChange}
            />
            <PeriodicityOption
              periodicity="yearly"
              value="yr"
              selected={selectedPeriodicity === "yr"}
              price={numberHasDecimal(planData?.planPriceYearPerMonth)}
              onClick={handleOptionChange}
              saveText={savePercentageText}
            />
          </div>
        </Row>
        <Row>
          <Col md={12}>
            <FieldText
              label="Billing Email"
              type="email"
              onChange={(x) => handleBillingEmail(x.target.value)}
              placeholder="Email address"
              value={billingEmail}
              error={billingMailError}
              required={true}
            />
          </Col>
        </Row>
        <Row>
          <Col className="col-md-12">
            <div className="form-group">
              <label>Card number</label>
              <CardNumberElement
                className="stripe-input"
                options={{
                  showIcon: true,
                  classes: { base: "form-control" },
                }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="col-md-3">
            <div className="form-group">
              <label>Expiration</label>
              <CardExpiryElement className="stripe-input" options={{ classes: { base: "form-control" } }} />
            </div>
          </Col>
          <Col className="col-md-3">
            <div className="form-group">
              <label>CVC</label>
              <CardCvcElement className="stripe-input" options={{ classes: { base: "form-control" } }} />
            </div>
          </Col>
        </Row>
        <Row>
          <div className="pay-resume">
            <span className="pay-resume-text">Billed Today: ${billedToday}</span>
          </div>
          <div className="pay-promocode">
            <Button variant="link" className={`button-link ${!showPromoCode ? `` : `d-none`}`} onClick={() => setShowPromoCode(true)}>
              Apply promo code
            </Button>
            <div className={`promo-container ${showPromoCode ? `` : `d-none`}`}>
              <FieldText
                type="text"
                classNames="no-margin-bottom"
                onChange={(x) => handlePromoCode(x.target.value)}
                placeholder="Promo code"
                value={promoCode}
                required={false}
                onBlur={checkPromoCode}
              />

              <Button variant="link" className={`button-link ${showPromoCode ? `` : `d-none`}`} onClick={() => setShowPromoCode(false)}>
                Hide promo code
              </Button>
            </div>
          </div>
          <div className="pay-btn">
            <Button type="submit" className={`btn btn-primary`} onClick={fetchCardToken}>
              {payText}
            </Button>
          </div>
          <div className="pay-text">
            By clicking {payText}, you agree to be charged ${chargePrice} {chargePeriod}
            {sevenDaytrialText}, unless you cancel.
          </div>
        </Row>
        <div className="features-list">
          <ul className="list-header">
            <li className="head">
              <div className="table-header">
                <Image src={MonkeyFace} width={24} height={24} />
                <h6>Socialchimp Features</h6>
              </div>
            </li>
            <li className="type special">
              <Image src={Bolt} width={18} height={18} />
              Pro
            </li>
            <li className="type">Base</li>
          </ul>

          <ul className="list-item">
            <li className="head">Unlimited AI content generation</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={NormalCheck} width={18} height={18} />
            </li>
          </ul>
          <ul className="list-item">
            <li className="head">Documentation access</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={NormalCheck} width={18} height={18} />
            </li>
          </ul>
          <ul className="list-item">
            <li className="head">Enterprise-level support</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={NormalCheck} width={18} height={18} />
            </li>
          </ul>
          <ul className="list-item">
            <li className="head">Customizable AI prompts</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={Nope} width={18} height={18} />
            </li>
          </ul>
          <ul className="list-item">
            <li className="head">Dedicated account manager</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={Nope} width={18} height={18} />
            </li>
          </ul>
          <ul className="list-item">
            <li className="head">Full API integration</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={Nope} width={18} height={18} />
            </li>
          </ul>
          <ul className="list-item">
            <li className="head">Turbo AI generation</li>
            <li className="check">
              <Image src={CheckSpecial} width={18} height={18} />
            </li>
            <li className="check">
              <Image src={Nope} width={18} height={18} />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
